export const DEFAULT_ACTIVATION_STATE = {
  workflowVersion: 2,
  complete: false,
  currentStep: 1,
  step1: {
    targetMonthlyCashflowGross: '',
    targetExitNetWorth: '',
    timeframeYears: '',
    availableCapital: '',
    jvCapitalAccess: '',
    executionScore: null,
    targetsLocked: false,
    askRobConversation: [],
  },
  step2: {
    operatingPreference: '',
    primaryStrategy: '',
    secondaryStrategy: null,
    strategyLocked: false,
    strategyLockedAt: null,
    strategyAttributes: {
      deliveryIntensity: null,
      returnRealisationSpeed: null,
      complexityRating: null,
      dealBias: null,
    },
    primaryFocusRatio: null,
    secondaryFocusRatio: null,
    selectionRationale: null,
  },
  step3: {
    preferredLocation: '',
    preferredLocationGazetteerEntryId: null,
    maxTravelValue: '',
    travelUnit: 'miles',
    selectedPostcodes: [],
    selectedMarketId: null,
    territorySelectionMode: null,
    territorySuggestionId: null,
    selectionIdempotencyKey: null,
    activeTerritory: null,
    postcodeRecommendationsMarketId: null,
    selectedPostcodeTargets: [],
    areaSuggestions: null,
    areaMarketAnalysis: null,
    areaRecommendations: null,
  },
  step4: { primaryMetric: '', primaryThreshold: '', secondaryMetric: '', secondaryThreshold: '' },
  step5: { primaryMetric: '', primaryThreshold: '', secondaryMetric: '', secondaryThreshold: '' },
}
